import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from './SectionHeader';
import { GiftIcon } from 'lucide-react';
const bonos = [{
  id: 'B1',
  title: 'Tabla de Hitos del Desarrollo del Lenguaje de 0 a 12 Años',
  desc: 'Tu referencia clínica de consulta rápida. Imprimila y tenela a la vista en el consultorio todos los días.',
  image: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=160&h=160&q=70&fit=crop&auto=format',
  alt: 'Tabla de hitos del desarrollo del lenguaje infantil'
}, {
  id: 'B2',
  title: 'Guía de Respuestas ante las 10 Situaciones Clínicas que Más Incomodan',
  desc: 'Qué decir cuando los padres preguntan "¿es grave?", cuando el niño no coopera o cuando un padre viene enojado. Guiones listos para usar.',
  image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=160&h=160&q=70&fit=crop&auto=format',
  alt: 'Profesional dialogando con una familia en consulta'
}, {
  id: 'B3',
  title: 'Plantilla de Seguimiento de Pacientes — Registro Sesión por Sesión',
  desc: 'Todo el historial de tu paciente en 30 segundos antes de cada sesión. Ficha editable en PDF y Excel.',
  image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=160&h=160&q=70&fit=crop&auto=format',
  alt: 'Planilla de seguimiento clínico de pacientes'
}];
export function BonosSection() {
  return <section className="py-12 md:py-20 px-4 md:px-8 bg-teal-900 text-white" data-id="element-23">
      <div className="max-w-3xl mx-auto" data-id="element-24">
        <SectionHeader eyebrow="INCLUIDOS GRATIS" title={<span className="text-white" data-id="element-26">3 Bonos de Alto Valor Clínico</span>} subtitle={<span className="text-teal-100" data-id="element-27">
              Sin costo extra — incluidos en todas las ofertas
            </span>} className="mb-8 md:mb-12" data-id="element-25" />

        <div className="bg-teal-800/40 rounded-2xl md:rounded-3xl border border-teal-700 overflow-hidden divide-y divide-teal-700/60 mb-6 md:mb-8" data-id="element-28">
          {bonos.map((bono, index) => <motion.div key={bono.id} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-30px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="group flex items-start gap-3 md:gap-5 p-3 md:p-5 hover:bg-teal-800/60 transition-colors relative" data-id="element-29">
              {/* Image thumbnail */}
              <div className="shrink-0 relative" data-id="element-30">
                <div className="w-16 h-16 md:w-20 md:h-20 rounded-xl overflow-hidden bg-teal-700 border border-teal-600" data-id="element-31">
                  <img src={bono.image} alt={bono.alt} width="80" height="80" loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-32" />
                </div>
                <span className="absolute -top-1.5 -right-1.5 bg-terracotta text-white font-bold text-[9px] md:text-[10px] px-1.5 py-0.5 rounded shadow flex items-center gap-0.5 uppercase tracking-wider" data-id="element-33">
                  <GiftIcon size={10} data-id="element-34" /> Gratis
                </span>
              </div>

              {/* Content */}
              <div className="flex-grow min-w-0 pt-0.5" data-id="element-35">
                <div className="flex items-baseline gap-2 mb-1" data-id="element-36">
                  <span className="text-teal-400 font-bold text-xs md:text-sm" data-id="element-37">
                    {bono.id}
                  </span>
                  <h3 className="font-bold text-white leading-tight text-sm md:text-base font-serif" data-id="element-38">
                    {bono.title}
                  </h3>
                </div>
                <p className="text-xs md:text-sm text-teal-100/80 leading-relaxed" data-id="element-39">
                  {bono.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-40">
          <div className="inline-block bg-teal-950 px-5 md:px-8 py-3 md:py-4 rounded-xl border border-teal-800" data-id="element-41">
            <span className="text-sm md:text-base text-teal-300 font-medium mr-2 md:mr-3" data-id="element-42">
              VALOR TOTAL:{' '}
              <span className="line-through opacity-70" data-id="element-43">$42.000</span>
            </span>
            <span className="text-lg md:text-2xl font-bold text-white tracking-wide" data-id="element-44">
              — GRATIS
            </span>
          </div>
        </div>
      </div>
    </section>;
}